import { EMBRYO_STATUS, IMPLANTABLE_STATUSES } from './constants';

export function validateStatusChange(
  currentStatus: number | undefined,
  newStatus: number | undefined,
): { valid: boolean; message?: string } {
  if (!currentStatus || !newStatus || currentStatus === newStatus) {
    return { valid: true };
  }

  if (
    newStatus === EMBRYO_STATUS.IMPLANTED &&
    !(IMPLANTABLE_STATUSES as readonly number[]).includes(currentStatus)
  ) {
    return {
      valid: false,
      message: 'Only Frozen or Shipped embryos can be marked as Implanted.',
    };
  }

  if (
    currentStatus === EMBRYO_STATUS.IMPLANTED &&
    !(IMPLANTABLE_STATUSES as readonly number[]).includes(newStatus)
  ) {
    return {
      valid: false,
      message:
        'Implanted embryos can only be returned to Frozen or Shipped status.',
    };
  }

  return { valid: true };
}

export function validateReversalFields(
  storageLocationId: string | null | undefined,
  siteId: string | null | undefined,
): { valid: boolean; message?: string } {
  const missingSL = !storageLocationId;
  const missingSite = !siteId;
  if (missingSL || missingSite) {
    const parts = [
      missingSL && 'Storage Location',
      missingSite && 'Site',
    ].filter(Boolean);
    return {
      valid: false,
      message: `${parts.join(' and ')} ${parts.length > 1 ? 'are' : 'is'} required when returning an embryo to Frozen.`,
    };
  }
  return { valid: true };
}

export function validateBulkImplantStatuses(
  embryos: Array<{ status?: number }>,
): { valid: boolean; message?: string } {
  const invalidEmbryos = embryos.filter((embryo) => {
    const s = embryo.status;
    return (
      s != null && !(IMPLANTABLE_STATUSES as readonly number[]).includes(s)
    );
  });

  if (invalidEmbryos.length > 0) {
    return {
      valid: false,
      message: `${invalidEmbryos.length} embryo(s) cannot be implanted. Only Frozen or Shipped embryos can be implanted.`,
    };
  }

  return { valid: true };
}

export function applyImplantBillingDefault(
  setValue: (field: string, value: string) => void,
  embryo: {
    implantBillingAccountId?: string | null;
    ownerId?: string | null;
    ownerName?: string | null;
  },
) {
  if (!embryo.implantBillingAccountId && embryo.ownerId) {
    setValue('implantBillingAccountId', embryo.ownerId);
    setValue('implantBillingAccountName', embryo.ownerName ?? '');
  }
}

export function validateImplantDate(date: Date | string | undefined): {
  valid: boolean;
  message?: string;
} {
  if (!date) {
    return { valid: true };
  }

  const implantDate = typeof date === 'string' ? new Date(date) : date;
  const today = new Date();
  today.setHours(23, 59, 59, 999);

  if (implantDate > today) {
    return {
      valid: false,
      message: 'Implant date cannot be in the future',
    };
  }

  return { valid: true };
}
